import { Component, OnInit, OnDestroy, Renderer2, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';

@Component({
  selector: 'app-ios-updates',
  imports: [CommonModule, RouterModule],
  standalone: true,
  templateUrl: './ios-updates.component.html',
  styleUrl: './ios-updates.component.scss'
})
export class IosUpdatesComponent implements OnInit, OnDestroy {
  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }
  private jsonLdScript: any;
  nav(url: any) {
    this.router.navigateByUrl(url)
  }
  ngOnInit(): void {
    this.injectSchemaMarkup();
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route: { data: any; }) => route.data)
    )
      .subscribe((event: any) => {
        if (this.router.url === '/blogs/ios-updates') {
          this.updateDescription(event.description, event.keywords, event.title);
        }
      });
  }
  ngOnDestroy(): void {
    this.removeSchemaMarkup();
  }
  injectSchemaMarkup(): void {
    const iosUpdatesSchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/ios-updates#webpage",
          "url": "https://www.kalpitatechnologies.com/tech-blogs/ios-updates",
          "name": "Everything You Need to Know About iOS 18: Key Updates and Features | Kalpita Technologies",
          "description": "Comprehensive guide to iOS 18 updates including Apple Intelligence, Xcode 16, SwiftData, Swift Testing, RealityKit, and Siri enhancements.",
          "isPartOf": { "@id": "https://www.kalpitatechnologies.com/#website" },
          "inLanguage": "en",
          "datePublished": "2024-12-03"
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/ios-updates#breadcrumb",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.kalpitatechnologies.com" },
            { "@type": "ListItem", "position": 2, "name": "Blog Index", "item": "https://www.kalpitatechnologies.com/tech-blogs/blog" },
            { "@type": "ListItem", "position": 3, "name": "iOS 18 Updates", "item": "https://www.kalpitatechnologies.com/tech-blogs/ios-updates" }
          ]
        },
        {
          "@type": "BlogPosting",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/ios-updates#article",
          "headline": "Everything You Need to Know About iOS 18: Key Updates and Features",
          "articleBody": "iOS reshapes the user experience with its new release every time. This September they've released iOS 18 built around Apple Intelligence—the AI feature set deeply integrated into iOS...",
          "author": {
            "@type": "Person",
            "name": "Himagiri",
            "url": "https://www.kalpitatechnologies.com/author/himagiri"
          },
          "publisher": {
            "@type": "Organization",
            "name": "Kalpita Technologies",
            "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
          },
          "datePublished": "2024-12-03",
          "image": "https://www.kalpitatechnologies.com/assets/resources/blog/ios-updates/ios-banner.webp"
        },
        {
          "@type": "FAQPage",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/ios-updates#faq",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What is Apple Intelligence and how does it work in iOS 18?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Apple Intelligence is a system-wide AI feature set deeply integrated into iOS 18, bringing powerful generative models directly to your device while protecting privacy through on-device processing."
              }
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com/",
          "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
        }
      ]
    };

    this.jsonLdScript = this.renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(iosUpdatesSchema);
    this.renderer.appendChild(this._document.head, this.jsonLdScript);
  }

  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this.renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }

  updateDescription(desc: string, keywords: string, title: string) {
    // this.seoService.updateDescription(desc);
    // this.seoService.updateMetaKeywords(keywords);
    // this.seoService.updateTitle(title);
  }
}
